import React from "react";
import { DatePicker } from "antd";
import { p3StartTime, p3EndTime } from "@/models/layer";

function NavigateDatePicker({ value, onChange }) {
  return (
    <DatePicker
      disabledDate={(current) => {
        return !current.isBetween(p3StartTime, p3EndTime);
      }}
      allowClear={false}
      style={{ width: "100%" }}
      value={value}
      onChange={(value) => {
        onChange(value);
      }}
    />
  );
}

export default NavigateDatePicker;
